export default __webpack_public_path__ + "NY_logo.2dd59c15.svg";